import { createContext, ReactNode, useContext } from 'react';

export interface ProductJourney {
  open: (content: ReactNode, title: string, lifecycle?: ProductJourneyLifecycle) => void;
  close: VoidFunction;
  prepare: (url: string) => boolean | void;
  navigate: (url: string, beforeNavigate?: VoidFunction) => void;
  progress: (distance: number) => void;
  cancel: VoidFunction;
  carouselActive: boolean;
  isPDPVisible?: boolean;
  onPDPView?: VoidFunction;
  remember?: (data: unknown) => void;
}

export interface ProductJourneyLifecycle {
  onClose?: VoidFunction;
  onPDPView?: VoidFunction;
}

export const ProductJourneyContext = createContext<ProductJourney | null>(null);
export const useProductJourney = () => useContext(ProductJourneyContext);
